import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'

const MOpenQuestion = ({ data }) => {
  const { kicker, headline, text } = data

  return (
    <Section
      baseClass="m-HeroTeaser"
      className={
        data.layout === 'umbrella-branding' ? 'm-HeroTeaser--dachmarke' : data.layout === 'employer-branding' ? 'm-HeroTeaser--big' : ''
      }
      data={data}
      defaultPadding="large"
    >
      <div className="m-HeroTeaser-wrapper">
        <div className="m-HeroTeaser-container">
          <img
            className={`m-HeroTeaser-foregroundImage dfb-Image dfb-Image--lazyloading dfb-Image--1To1Ratio`}
            style={{ alignSelf: 'center' }}
            alt="DFB Logo"
            src={`/images/logos/dfb-white.png`}
            loading="lazy"
          />
          <div className="m-HeroTeaser-content">
            {kicker && <div className="m-HeroTeaser-topline">{kicker}</div>}
            {headline && (
              <DfbHeadline
                headline={headline}
                headline_level="h2"
                add_class="c-Headline u-Theme-dark m-HeroTeaser-headline dfb-Headline--h2 dfb-Headline"
              />
            )}
            {text && <DfbRte text={text} add_class="u-Theme-dark m-HeroTeaser-paragraph" />}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MOpenQuestion
